import {StyleSheet} from 'react-native';
import {Colors} from '../../../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'white',
    paddingHorizontal: 40,
    paddingVertical: 50,
    // justifyContent: 'space-between',
    marginHorizontal: 15,
    marginVertical: 30,
    borderRadius: 8,
    maxWidth: 600,
    alignSelf: 'center',
    width: '100%',
  },
  validation: {
    textAlign: 'center',
    marginTop: 30,
    color: 'black',
  },
  call: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 20,
    alignSelf: 'center',
    marginTop: 30,
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  number: {
    textAlign: 'center',
    fontSize: 12,
    fontWeight: '400',
    lineHeight: 20,
    alignSelf: 'center',
    fontFamily: 'TCCC-UnityHeadline Regular',
    color: Colors.GrayPallete.lightgrayThree,
  },
  simbol: {alignSelf: 'center', marginBottom: 50, width: 80, height: 120},
  containerInput: {marginBottom: 70},
});
